type ScrollHandlerProps = {
  htmlElement: HTMLDivElement | null;
  nextPage: () => void;
  threshold?: number;
};

export const handleScroll = ({ htmlElement, nextPage, threshold = 50 }: ScrollHandlerProps) => {
  if (htmlElement) {
    const { scrollTop, scrollHeight, clientHeight } = htmlElement;

    // Check if the user has scrolled near the bottom
    if (scrollHeight - scrollTop <= clientHeight + threshold) {
      nextPage();
    }
  }
};
